import React from "react";
import { arrayOf, shape, string, oneOf, object } from "prop-types";
import ArrowLink from "../ArrowLink/ArrowLink.jsx";
import parseISO from "date-fns/parseISO/index.js";
import format from "date-fns/format/index.js";

const propTypes = {
  applyLinkText: string.isRequired,
  detailsLinkText: string.isRequired,
  applicationDueText: string.isRequired,
  items: arrayOf(
    shape({
      title: string,
      summary: string,
      url: string,
      applicationStatus: oneOf(["Upcoming", "Open", "Closed"]),
      applicationDueDate: string,
      information: arrayOf(string),
      applyLink: shape({
        url: string,
        text: string,
        target: string,
      }),
    }),
  ),
  focusRef: object,
};

const RFPListing = (props) => {
  const {
    applyLinkText,
    detailsLinkText,
    applicationDueText,
    items,
    focusRef,
  } = props;

  return items && items.length > 0 ? (
    <section className="rfp-listing component">
      {items &&
        items.map((item, i) => (
          <div className="rfp-listing__rfp-item" key={i}>
            {item.title && (
              <div
                className="rfp-listing__rfp-title"
                ref={!item.url && i === 0 ? focusRef : null}
                tabIndex="-1"
              >
                {item.url ? (
                  <a
                    href={item.url}
                    ref={i === 0 ? focusRef : null}
                    data-gtm-element="rfp listing title link"
                    data-gtm-text={item.title}
                    data-gtm-link={item.url}
                  >
                    {item.title}
                  </a>
                ) : (
                  item.title
                )}
              </div>
            )}
            {item.summary && (
              <div className="rfp-listing__rfp-summary">{item.summary}</div>
            )}

            {item.applicationDueDate && (
              <div className="rfp-listing__meta-wrapper">
                <div className="rfp-listing__meta-info ">
                  {applicationDueText && (
                    <div className="rfp-listing__meta-label">
                      {applicationDueText}
                    </div>
                  )}

                  <div className="rfp-listing__meta-date">
                    {/* https://date-fns.org/v1.28.5/docs/format */}
                    {format(parseISO(item.applicationDueDate), "PP").toString()}
                  </div>
                </div>
              </div>
            )}
            {item.url && detailsLinkText && (
              <div className="rfp-listing__details-link">
                <ArrowLink
                  text={detailsLinkText}
                  href={item.url}
                  gtmElementLabel="rfp listing details link"
                />
              </div>
            )}
            {item.applyLink && item.applicationStatus === "Open" && (
              <div className="rfp-listing__application-link">
                <a
                  title={item.title}
                  className="btn btn--primary"
                  href={item.url}
                  data-gtm-element="rfp listing application link"
                  data-gtm-link={item.url}
                  data-gtm-text={item.title}
                >
                  {applyLinkText}
                </a>
              </div>
            )}

            {item.information && (
              <div className="rfp-listing__information">
                {item.information.map((info, i, arr) => (
                  <span key={i}>
                    <span>{info}</span>
                    {arr.length - 1 !== i ? (
                      <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                    ) : null}
                  </span>
                ))}
              </div>
            )}
          </div>
        ))}
    </section>
  ) : null;
};

RFPListing.propTypes = propTypes;
export default RFPListing;
